import { EMPTY_STRING } from '@uplift/constants';
import { VALIDATION_EMERGENCY_CONTACT_NAME, VALIDATION_EMERGENCY_CONTACT_PHONE, VALIDATION_EMERGENCY_CONTACT_RELATIONSHIP } from '@uplift/validations';
import * as Yup from 'yup';
import { useSaveProfileEmergencyContact } from '../../hooks';
import { useUpdateSettings } from '../../hooks/use-update-settings.hook';
import { useCurrentuser } from '@uplift/contexts';
import { useUserEmergencyContactQuery } from '@uplift/queries';


export type EmergencyContactFormType = {
  name: string;
  relationship: string;
  phone: string;
};


export const useEmergencyContactForm = () => {
  const me = useCurrentuser();
  const { onFormSubmitSuccess, onFormSubmitError } = useUpdateSettings();
  const { data: emergencyContact }  = useUserEmergencyContactQuery(me.id, { suspense: true });
  const saveProfileEmergencyContact = useSaveProfileEmergencyContact();

  const emergencyContactFormik = () => {
    const initialValues: EmergencyContactFormType = {
      name: emergencyContact?.name ?? EMPTY_STRING,
      relationship: emergencyContact?.relationship ?? EMPTY_STRING,
      phone: emergencyContact?.phone ?? EMPTY_STRING,
    };

    const validationSchema = Yup.object({
      name: VALIDATION_EMERGENCY_CONTACT_NAME,
      relationship: VALIDATION_EMERGENCY_CONTACT_RELATIONSHIP,
      phone: VALIDATION_EMERGENCY_CONTACT_PHONE
    });

    const onSubmit = async (values: EmergencyContactFormType) => {
      try {
        await saveProfileEmergencyContact(me.id, {
          name: values.name,
          phone: values.phone,
          relationship: values.relationship,
        });
        onFormSubmitSuccess();
      } catch (error) {
        onFormSubmitError();
      }
    };

    return { initialValues, validationSchema, onSubmit };
  };

  return { emergencyContactFormik };
};
